module.exports = __webpack_public_path__ + "static/media/oblong_k.42dd26e1.svg";